import { Breadcrumb, Col, Row, Container, Tab, Tabs } from "react-bootstrap";
import Header from "./Header";
import servicesImg from "../assets/images/16178.jpg";
import { ReactComponent as MobileIcon } from "../assets/images/mobile.svg";
import { ReactComponent as DesignIcon } from "../assets/images/web-design.svg";
import { ReactComponent as WebIcon } from "../assets/images/web-coding.svg";
import webImg from "../assets/images/web-dev.jpg";
import mobileAppImg from "../assets/images/mobile-app.jpg";
import uiUxImg from "../assets/images/ui-ux.jpg";
import webDesignImg from "../assets/images/web-design.jpg";
import { motion } from "framer-motion";
import Footer from "./Footer";
import "./Services.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

function Services() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("web");

  const mainServices = [
    {
      id: "web",
      title: "Scalable Web Platforms",
      icon: (
        <WebIcon
          style={{ height: "60px", fill: "#0089f9", stroke: "#0089f9" }}
        />
      ),
      image: webImg,
      description:
        "We build high-performance web platforms designed for global scale. From content ecosystems to interactive digital environments, our platforms are engineered for speed, security, and long-term growth.",
      features: [
        "Responsive & Mobile-First Design",
        "Custom Web Applications",
        "E-Commerce Solutions",
        "API Integration & Development",
        "Performance Optimization",
        "SEO-Friendly Architecture",
      ],
    },
    {
      id: "mobile",
      title: "Global Mobile Applications",
      icon: (
        <MobileIcon
          style={{ height: "60px", fill: "#0089f9", stroke: "#0089f9" }}
        />
      ),
      image: mobileAppImg,
      description:
        "Our mobile applications power productivity, creativity, and everyday digital life. Designed for the Play Store and App Store, they are optimized for scale, performance, and global reach.",

      features: [
        "iOS & Android Development",
        "Cross-Platform Solutions",
        "Native App Development",
        "App Store Optimization",
        "Real-time Features",
        "Secure Backend Integration",
      ],
    },
    {
      id: "design",
      title: "Tools & Utility Ecosystems",
      icon: (
        <DesignIcon
          style={{ height: "60px", fill: "#0089f9", stroke: "#0089f9" }}
        />
      ),
      image: webDesignImg,
      description:
        "We develop intelligent digital tools that simplify complex tasks and enhance user efficiency. Every product is built with scalability, automation, and long-term usability in mind.",

      features: [
        "Brand Identity Design",
        "Prototyping & Wireframing",
        "Design Systems",
        "User Research & Testing",
        "Accessibility Compliance",
      ],
    },
    {
      id: "uiux",
      title: "Content & Gaming Platforms",
      icon: (
        <DesignIcon
          style={{ height: "60px", fill: "#0089f9", stroke: "#0089f9" }}
        />
      ),
      image: uiUxImg,
      description:
        "From professional blogging infrastructures to engaging gaming platforms, we create web experiences designed to grow communities and reach millions worldwide.",
      features: [
        "User Research & Journey Mapping",
        "Wireframes & Interactive Prototypes",
        "Design Systems & UI Kits",
        "Usability Testing",
        "Accessibility-First Design",
        "Conversion-Focused UX",
      ],
    },
  ];

  return (
    <>
      <div className="services-new">
        <div style={{}}>
          <Header />
        </div>

        {/* New Banner */}
        <div className="services-banner-new">
          <Container>
            <Row className="align-items-center g-5">
              {/* LEFT */}
              <Col lg={6} md={12}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="banner-content-services"
                >
                  {/* <div className="services-badge">Our Services</div> */}

                  <h1 className="services-title-new">Our Digital Products</h1>

                  <p className="services-text-new">
                    We design, build, and scale innovative mobile and web
                    products used by thousands of users worldwide.
                  </p>

                  <button
                    className="about-v2-btn mt-3"
                    onClick={() => navigate("/contact")}
                  >
                    Enquiry Now
                  </button>

                  {/* <div className="mt-4">
            <Breadcrumb className="breadcrumb-services">
              <Breadcrumb.Item
                className="breadcrumb-item-services"
                onClick={() => navigate("/")}
              >
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                className="breadcrumb-item-services"
                active
              >
                Services
              </Breadcrumb.Item>
            </Breadcrumb>
          </div> */}
                </motion.div>
              </Col>

              {/* RIGHT IMAGE */}
              <Col lg={6} md={12} className="text-lg-end">
                <motion.img
                  src={servicesImg}
                  alt="Services"
                  className="services-hero-image"
                  initial={{ opacity: 0, x: 40 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                />
              </Col>
            </Row>
          </Container>
        </div>

        {/* Tabbed Services Section */}
        <Container className="services-tabs-section">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-5"
          >
            <div className="section-label-services">Our Products</div>
            <h2 className="section-title-services">
              Built For Real-World Impact
            </h2>
          </motion.div>

          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="custom-tabs"
          >
            {mainServices.map((service) => (
              <Tab
                key={service.id}
                eventKey={service.id}
                title={
                  <div className="tab-title-wrapper">
                    {service.icon}
                    <span>{service.title}</span>
                  </div>
                }
              >
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <Row className="align-items-center">
                    <Col lg={6} md={12} className="mb-4 mb-lg-0">
                      <div className="service-tab-content">
                        <h3 className="service-tab-title">{service.title}</h3>
                        <p className="service-tab-description">
                          {service.description}
                        </p>
                        <div className="features-list">
                          {service.features.map((feature, idx) => (
                            <div key={idx} className="feature-item">
                              <span className="feature-check">✓</span>
                              <span>{feature}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} md={12}>
                      <div className="service-icon-display">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="service-image"
                        />
                      </div>
                    </Col>
                  </Row>
                </motion.div>
              </Tab>
            ))}
          </Tabs>
        </Container>

        <Footer />
      </div>
    </>
  );
}

export default Services;
